import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ReportViewDirective } from '@app/main/report-view/directives/report-view.directive';
import { CacheService } from '@shared/services/cache.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportService } from '@shared/services/report.service';
import { GuardService } from '@shared/services/guard.service';
import { ReportViewService } from '@app/main/report-view/servicies/report-view.service';
import { NavigationService } from '@shared/services';
import { Location } from '@angular/common';

@Component({
    selector: 'app-report-view-view',
    templateUrl: './report-view-view.component.html',
    styleUrls: ['./report-view-view.component.scss'],
    standalone: false
})
export class ReportViewViewComponent extends ReportViewDirective implements OnInit {
    constructor(
        protected guardService: GuardService,
        protected changeDetection: ChangeDetectorRef,
        protected cacheService: CacheService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected location: Location,
        protected navigationService: NavigationService,
        protected reportViewService: ReportViewService,
        protected reportService: ReportService
    ) {
        super(
            guardService,
            changeDetection,
            cacheService,
            router,
            route,
            location,
            navigationService,
            reportViewService,
            reportService
        );
    }

    public async ngOnInit(): Promise<void> {
        await super.ngOnInit();
    }
}
